import React from "react";

export const Raw = ({block}) => {
  return <div dangerouslySetInnerHTML={{__html: block.data.html}}/>
}